<template>
    <div class="m-main">
        <span class="m-title" v-html="$t('hymn')"></span>
        <p align="justify" v-html="$t('hymnTxt1')"></p>
        <p align="justify" v-html="$t('hymnTxt2')"></p>
        <v-card style="width: 100%">
            <v-card-text>
                <div class="m-txt">
                    <div style="width: 300px; color: black">
                        <p>Ак мөңгүлүү аска, зоолор, талаалар,<br>
                        Элибиздин жаны менен барабар.<br>
                        Сансыз кылым Ала-Тоосун мекендеп,<br>
                        Сактап келди биздин ата-бабалар!</p><p>
                        <span style="font-style: italic">Кайырма:</span><br>
                        Алгалай бер, кыргыз эл,<br>
                        Азаттыктын жолунда.<br>
                        Өркүндөй бер, өсө бер,<br>
                        Өз тагдырың колуңда.</p>
                        <p>Аткарылып элдин үмүт тилеги,<br>
                            Желбиреди эркиндиктин желеги.<br>
                            Бизге жеткен ата салттын, мурасын,<br
                            >Ыйык сактап урпактарга берели.</p>
                        <p><span style="font-style: italic">Кайырма:</span><br>
                            Алгалай бер, кыргыз эл,<br>
                            Азаттыктын жолунда.<br>
                            Өркүндөй бер, өсө бер,
                            <br>Өз тагдырың колуңда.</p>
                    </div>
                    <v-divider vertical/>
                    <div style="width: 300px; color: black"><p>Высокие горы, долины, поля –<br>
                        Родная, заветная наша земля.<br>
                        Отцы наши жили среди Ала-Тоо<br>
                        Всегда свою родину свято храня.</p><p>
                        <span style="font-style: italic">Припев:</span><br>
                        Вперёд, киргизский народ,<br>
                        Путем свободы вперёд!<br>
                        Взрастай, народ, расцветай,<br>
                        Свою судьбу созидай!</p>
                        <p>Мечты и надежды отцов сбылись.<br>
                            И знамя свободы возносится ввысь.<br>
                            Наследье отцов наших передадим<br>
                            На благо народа потомкам своим</p><p>
                            <span style="font-style: italic">Припев:</span><br>
                            Вперёд, киргизский народ,<br>
                            Путем свободы вперёд!<br>
                            Взрастай, народ, расцветай,<br>
                            Свою судьбу созидай!</p>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-8S0M681ZDD"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
export default {
  name: 'Hymn'
}
</script>

<style scoped>
.m-main{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 30px;
    max-width: 750px;
}
.m-title{
    font-weight: 600;
    font-size: 30px;
    padding-bottom: 20px;
}
.m-txt{
    display: flex; flex-direction: row; flex-wrap: wrap; gap: 12px; justify-content: space-between
}

</style>
